'use client'

import PopupNotification from "@/app/components/atomic/PopupNotification";
import { usePopupNotificationStore } from "@/app/stores/popup-notification-store";

export default function PopupNotificationProvider() {
    const { notification, hideNotification } = usePopupNotificationStore();

    return (
        <PopupNotification 
            config={notification} 
            onClose={hideNotification} 
        />
    );
}

